function englishAlphabet() {
	return this
		.test({
			test(value) {
				return  (value.match(/^[a-zA-Z.-]*$/))
			},
		})
} // englishAlphabet()

function englishNumeric() {
	return this
		.test({
			test(value) {
				return  (value.toString().match(/^[0-9]*$/))
			},
		})
} // englishNumeric()
function setup(yup) {
	yup.addMethod(yup.string, 'englishAlphabet', englishAlphabet)
	yup.addMethod(yup.string, 'englishNumeric', englishNumeric)
	yup.addMethod(yup.number, 'englishNumeric', englishNumeric)
}

export default setup;
